import {
    GET_PROVIDERS_OUTSTANDING_REQUEST,
    GET_PROVIDERS_OUTSTANDING_RESPONSE,
    GET_TRANSACTIONS_REQUEST,
    GET_TRANSACTIONS_RESPONSE,
    GET_SETTLEMENTS_REQUEST,
    GET_SETTLEMENTS_RESPONSE,
    CREATE_SETTLEMENT,
    EXPORT_SETTLEMENTS,
    GET_REQUEST_STATUS,
    GET_FIXED_COMMISSION_FEES_REQUEST,
    GET_FIXED_COMMISSION_FEES_RESPONSE,
} from './types';

export const getProvidersOutstandingRequest = (payload) => ({
    type: GET_PROVIDERS_OUTSTANDING_REQUEST,
    payload
});
export const getProvidersOutstandingResponse = (payload) => ({
    type: GET_PROVIDERS_OUTSTANDING_RESPONSE,
    payload
});

export const getTransactionsRequest = (payload) => ({
    type: GET_TRANSACTIONS_REQUEST,
    payload
});
export const getTransactionsResponse = (payload) => ({
    type: GET_TRANSACTIONS_RESPONSE,
    payload
});

export const createSettlement = (payload) => ({
    type: CREATE_SETTLEMENT,
    payload
})

export const getSettlementsRequest = (payload) => ({
    type: GET_SETTLEMENTS_REQUEST,
    payload
});
export const getSettlementsResponse = (payload) => ({
    type: GET_SETTLEMENTS_RESPONSE,
    payload
});

export const exportSettlements = (payload) => ({
    type: EXPORT_SETTLEMENTS,
    payload,
 });

export const getRequestStatus = (payload) => ({
    type: GET_REQUEST_STATUS,
    payload,
});

export const getFixedCommissionFeesRequest = (payload) => ({
    type: GET_FIXED_COMMISSION_FEES_REQUEST,
    payload
});
export const getFixedCommissionFeesResponse = (payload) => ({
    type: GET_FIXED_COMMISSION_FEES_RESPONSE,
    payload
});

